<template>
    <div class="tab-detail">
        <div class="header">
            <div class="title">{{ $t("youtubeChannel.visibilitySettings") }}</div>
            <div class="subtitle">{{ $t("youtubeChannel.visibilityDescription") }}</div>
        </div>
        <div class="form-wrapper">
            <div class="input-wrapper">
                <label>{{ $t("youtubeChannel.users") }}</label>
                <a-select
                    mode="multiple"
                    v-model="form.users"
                    :placeholder="$t('youtubeChannel.selectUsers')"
                    style="width: 100%"
                    :filter-option="filterOption"
                >
                    <a-select-option v-for="user in users" :key="user._id" :value="user._id">
                        {{ user.fullName }}
                    </a-select-option>
                </a-select>
            </div>
            <div class="input-wrapper">
                <label>{{ $t("youtubeChannel.departments") }}</label>
                <a-select
                    mode="multiple"
                    v-model="form.departments"
                    :placeholder="$t('youtubeChannel.selectDepartments')"
                    style="width: 100%"
                    :filter-option="filterOption"
                >
                    <a-select-option v-for="dept in departments" :key="dept._id" :value="dept._id">
                        {{ dept.name }}
                    </a-select-option>
                </a-select>
            </div>
            <div class="input-wrapper">
                <label>{{ $t("youtubeChannel.owners") }}</label>
                <a-select
                    mode="multiple"
                    v-model="form.owners"
                    :placeholder="$t('youtubeChannel.selectOwners')"
                    style="width: 100%"
                    :filter-option="filterOption"
                >
                    <a-select-option v-for="user in users" :key="user._id" :value="user._id">
                        {{ user.fullName }}
                    </a-select-option>
                </a-select>
            </div>
        </div>
        <div class="form-footer">
            <div class="actions">
                <a-button class="pr-confirm-btn" @click="handleSave" type="primary" :loading="loading">
                    {{ $t("message.update") }}
                </a-button>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from "vue";
import { mapActions, mapState } from "vuex";
import _ from "lodash";

export default Vue.extend({
    name: "Visibility",
    props: {
        value: {
            required: true,
        },
    },
    data() {
        return {
            form: {
                users: [],
                departments: [],
                owners: [],
            },
            loading: false,
        };
    },
    computed: {
        ...mapState({
            users: (state) => state.user.userList,
            departments: (state) => _.get(state.subject.subjects, "data", []) || [],
        }),
    },
    methods: {
        ...mapActions({
            updateChannel: "channel/updateChannel",
            listUsers: "user/listUsers",
            listSubjects: "subject/getAllSubjects",
            listChannels: "channel/listChannels",
        }),
        filterOption(input, option) {
            return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
        },
        handleSave() {
            this.loading = true;
            const payload = _.cloneDeep(this.value);
            payload.visibility = {
                users: this.form.users,
                departments: this.form.departments,
                owners: this.form.owners,
            };
            this.updateChannel(payload)
                .then(() => {
                    this.listChannels();
                    this.$message.success(this.$t("youtubeChannel.channelUpdatedSuccess"));
                    this.$emit("input", payload);
                    this.$emit("saved");
                })
                .catch((err) => {
                    console.error(err);
                    this.$message.error(this.$t("youtubeChannel.failedUpdateChannel"));
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        initForm() {
            if (this.value && this.value.visibility) {
                this.form.users = this.value.visibility.users || [];
                this.form.departments = this.value.visibility.departments || [];
                this.form.owners = this.value.visibility.owners || [];
            }
        },
    },
    watch: {
        value: {
            immediate: true,
            handler() {
                this.initForm();
            },
        },
    },
    mounted() {
        this.listUsers();
        this.listSubjects();
    },
});
</script>

<style scoped lang="scss">
.tab-detail {
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 20px;

    .header {
        display: flex;
        flex-direction: column;
        padding-bottom: 10px;
        border-bottom: 1px solid var(--color-border-default);

        .title {
            font-size: 18px;
            font-weight: 700;
            color: var(--color-text-strong-default);
        }

        .subtitle {
            font-size: 14px;
            color: var(--color-text-default);
        }
    }

    .form-wrapper {
        display: flex;
        flex-direction: column;
        gap: 20px;
        max-width: 500px;

        .input-wrapper {
            display: flex;
            flex-direction: column;
            gap: 8px;

            label {
                font-weight: 500;
            }
        }
    }

    .form-footer {
        margin-top: 20px;

        .actions {
            display: flex;
            gap: 10px;
        }
    }
}
</style>
